import { render, staticRenderFns } from "./RevisarAuto.vue?vue&type=template&id=5d4e0fed&scoped=true&"
import script from "./RevisarAuto.vue?vue&type=script&lang=js&"
export * from "./RevisarAuto.vue?vue&type=script&lang=js&"
import style0 from "./RevisarAuto.vue?vue&type=style&index=0&id=5d4e0fed&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4e0fed",
  null
  
)

export default component.exports